import { squaresApi } from '../../../api';
import type { Square, AssignSquareInput } from '../../../types';
import type { SquareStateGetter } from '../types';

export const createAssignSquare = (get: SquareStateGetter) => {
  return async (boardId: string, input: AssignSquareInput): Promise<Square> => {
    const square = await squaresApi.assign(boardId, input);
    await get().fetchSquares(boardId);
    return square;
  };
};
